export default function masterProductDirective() {
  console.log('app.components.admin.vendorManagementAdmin.masterProductDirective created');
  return {
    template: require('./master-product.directive.html'),
    controller: 'VMAMasterProductDirectiveController',
    controllerAs: 'vmaMasterProductVM',
    bindToController: true,
    replace: true,
    scope: {
      masterProduct: '='
    },
  };
}
